module.exports = __webpack_public_path__ + "img/vip-coupon.06630b9d.png";